<div class="container-fluid">
  <div class="container-fluid">
    <h1
      style="
        font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto,
          Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
        text-align: center;
      "
    >
      Find Your Repos
    </h1>
  </div>

  <div class="container-fluid" style="margin-bottom: 2%">
    <div class="row justify-content-start">
      <div class="col-4">
        <input
          class="form-control"
          type="text"
          name="username"
          placeholder="Github username"
          [(ngModel)]="username"
        />
      </div>
      <div class="col-4">
        <button class="btn btn-dark" (click)="getRepos()">Get Repos</button>
      </div>
    </div>
  </div>

  <div class="container-fluid">
    <table class="table table-dark table-striped">
      <thead>
        <tr style="background-color: black; color: white; font-style: bold">
          <th class="td">ID</th>
          <th class="td">Name</th>
          <th class="td">Description</th>
          <th class="td">URL</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let repo of repos">
          <td>{{ repo.id }}</td>
          <td>{{ repo.name }}</td>
          <td>{{ repo.description }}</td>
          <td>
            <a
              href="{{ repo.html_url }}"
              target="_blank"
              routerLinkActive="active"
              >{{ repo.html_url }}</a
            >
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="container-fluid">
    <div
      *ngIf="errorMessage"
      class="alert alert-danger d-flex align-items-center"
      role="alert"
    >
      <div><strong> ¡Error! </strong> {{ errorMessage | json }}</div>
    </div>
  </div>

  <div class="d-flex justify-content-center">
    <div class="spinner-grow text-dark" role="status" *ngIf="loading">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>

  <p style="font-style: italic; margin-top: 2%">Data from GitHub</p>
</div>
